import React, { useState } from "react";

//import localization
import { useTranslation } from "react-i18next";

import { Modal, Divider, Form, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import http from "../utils/http";
import GeneralErrorMsg from "../utils/GeneralErrorMsg";

const { confirm, success } = Modal;

function CancelForm({ query }) {
	const { t } = useTranslation();
	//loadingState: Used for the loading indication on the Cancel button
	const [loadingState, setLoadingState] = useState(false);

	const onFinish = (values) => {
		confirm({
			icon: <ExclamationCircleOutlined />,
			title: t("Warning"),
			content: <div>{t("AreYouSureYouWantToContinue")}</div>,
			cancelText: t("No"),
			okText: t("Yes"),
			centered: true,

			onOk() {
				http
					.get(`/travelinsurancesingle/canceloffer`, {
						params: {
							o: query.OfferId
						}
					})
					.then((response) => {
						if (response.status === 200) {
							//Success Message
							success({
								title: t("YourRequestHasBeenCompleted"),
								centered: true
							});
						} else if (response.status === 604) {
							GeneralErrorMsg({ title: t("ErrorMessageTitle"), content: t("YouAreUnableToSumbitAnObjectionSinceYourTripHasBegun") });
						} else {
							GeneralErrorMsg({ title: t("ErrorMessageTitle"), content: t("ErrorMessageContent") });
						}
						//Set button's loading state to false
						setLoadingState(false);
					})
					.catch((error) => {
						if (error.response.status === 604 || error.response.status === 602) {
							GeneralErrorMsg({ title: t("ErrorMessageTitle"), content: t("YouAreUnableToSumbitAnObjectionSinceYourTripHasBegun") });
						} else {
							GeneralErrorMsg({ title: t("ErrorMessageTitle"), content: t("ErrorMessageContent") });
						}

						//Set button's loading state to false
						setLoadingState(false);
					});
			},
			onCancel() {
				setLoadingState(false);
			}
		});
	};

	return (
		<>
			<h1 className="page-header" style={{ textAlign: "center", color: "white" }}>
				{t("ObjectionRequest")}
			</h1>
			<Form style={{ padding: 24 }} name="cancel-form" onFinish={onFinish}>
				{/* <Form.Item name="comment" label="Comment">
				<Input.TextArea placeholder="Please tell us why you are canceling..." autoSize={{ minRows: 3 }} showCount maxLength={500} />
			</Form.Item> */}
				{t("ObjectRequest14Limit")}

				{t("YouAreNotAbleToSubmitAnObjection")}
				<Divider style={{ margin: "14px 0px" }} />
				<Button type="primary" htmlType="submit" block loading={loadingState} onClick={() => setLoadingState(true)}>
					{t("Confirm")}
				</Button>
			</Form>
		</>
	);
}

export default CancelForm;
